import "react-app-polyfill/stable";
import "core-js";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import * as ReactDOMClient from "react-dom/client";
import { createAPIInstance } from "@dobrh-monorepo/routing";
import { Navigate } from "react-router-dom";

// API instance initialization
createAPIInstance(process.env.NX_PUBLIC_API_URL!, () => {
  localStorage.clear();
  return Navigate({ to: "/login" });
});

// @ts-expect-error TS(2345): Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
